module.exports = __webpack_public_path__ + "images/cv_bulk_copy_b741c603c57a02735c2212c8b9ad61ba.png";